module.exports = __webpack_public_path__ + "media/images/Icon-change-done-5338ce6e3aa2411e24f1f948960bb7e9.svg";